import { FormControl, Grid, InputLabel, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import React from 'react';
import Paper from '@mui/material/Paper';
import { styled } from 'styled-components';
import PerfilRealizacoes from '../PerfilRealizacoes';
import { useTranslation } from '../../../../../commons/useTranslasion';

interface Props {
  novoUsuario: boolean;
}

const PPCStepper3: React.FC<Props> = (props: Props) => {
  const { translate } = useTranslation();
  const { novoUsuario } = props;
  const methods = useFormContext();

  return (
    <>
      <Grid container xs={12} md={12} sm={12} lg={12} sx={{
        display: "flex",
        flexWrap: "wrap",
        width: "100% !important",
      }}>
        <Grid xs={12} md={12} sm={12} >
          <Typography sx={{
            padding: "10px 0px", display: "flex",
            width: "100% !important",
          }} variant="h5" component="h2">
            {translate('resultadosRealizacaoCompetencia')}
          </Typography>
        </Grid>
        <Grid container xs={12} md={12} sx={{ paddingBottom: "10px", display: "flex" }}>
          <Typography sx={{ padding: "10px 0px" }} variant="caption">
            {translate('resultadosRealizacaoCompetenciaTexto1')}
          </Typography>
         
          <Grid>
            <ul>
              <li style={{ fontSize: "14px", paddingBottom: "10px" }}>
                {translate('resultadosRealizacaoCompetenciaTexto2')}
              </li>
              <li style={{ fontSize: "14px", paddingBottom: "10px" }}>
                {translate('resultadosRealizacaoCompetenciaTexto3')}
              </li>
              <li style={{ fontSize: "14px", paddingBottom: "10px" }}>
                {translate('resultadosRealizacaoCompetenciaTexto4')}
              </li>
              <li style={{ fontSize: "14px", paddingBottom: "10px" }}>
                {translate('resultadosRealizacaoCompetenciaTexto5')}
              </li>
            </ul>
          </Grid>

          <Grid>
            <Paragrafo>
              {translate('resultadosRealizacaoCompetenciaTexto6')}
            </Paragrafo>
            <Paragrafo>
              {translate('problemaDesafioTexto1')}
              {/* <b>O PROBLEMA-DESAFIO: </b>
              (Descreva qual era o cenário e o desafio que enfrentou). Trata-se de uma OPORTUNIDADE ou um PROBLEMA que vivenciou. Explore bem! */}
            </Paragrafo>
            <Paragrafo>
              {translate('acaoOuAcoesTexto')}
              {/* <b>A AÇÃO OU AÇÕES: </b>
              (Como enfrentou este desafio? Qual foi o seu papel e o que você fez?). Descreva o passo a passo das ações que você realizou diante do cenário apresentado acima, quais os obstáculos que você enfrentou e quais os recursos que utilizou. Escreva em 1a. pessoa. */}
            </Paragrafo>
            <Paragrafo>
              {translate('resultadoTexto')}
              {/* <b>O RESULTADO: </b>
              (Qual resultado obteve com este desafio?). Pense nos resultados QUANTITATIVOS ou QUALITATIVOS obtidos (números, pessoas, percentuais, economias, melhorias, quantidades, dimensões e ganhos). Ou seja, considere os benefícios que gerou para a EMPRESA e/ou ÁREA em que atuava. */}
            </Paragrafo>
            <Paragrafo>
              {translate('sinteseTexto')}
              {/* <b>SÍNTESE: </b>
              Reúna o que descreveu nesses dois tópicos (desafio + resultados obtidos). Elabore estas frases e reescreva num ÚNICO ‘bullet point”: será útil no seu CV. */}
            </Paragrafo>
            <Paragrafo>
              {translate('competenciasTexto')}
              {/* <b>COMPETÊNCIAS: </b>
              (Quais competências você entende que utilizou para vencer esse desafio e/ou desenvolveu A PARTIR desse desafio). */}
            </Paragrafo>

            <Paragrafo><b>{translate('exemplo')}:</b></Paragrafo>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="caption table">
                <TableBody>
                  <TableRow>
                    <TableCell width={"200px"}>
                      <b>{translate('problemaDesafioTitulo')}</b>
                    </TableCell>
                    <TableCell>
                      {translate('problemaDesafioTexto')}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <b>{translate('acaoTituloP1')}</b>
                    </TableCell>
                    <TableCell>
                      {translate('acaoTexto')}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <b>{translate('resultadosTitulo')}</b>
                    </TableCell>
                    <TableCell>
                      {translate('resultadosTexto')}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <b>{translate('sinteseTitulo')}</b>
                    </TableCell>
                    <TableCell>
                      {translate('sinteseTexto1')}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <b>{translate('CompetenciaTitulo')}</b>
                    </TableCell>
                    <TableCell>
                      {translate('CompetenciaTexto')}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <br />
            <Paragrafo>
              {translate('descricaoInfo')}
            </Paragrafo>
          </Grid>
        </Grid>

        <Grid container xs={12} md={12} sm={12} sx={{ paddingBottom: "10px", display: "flex", width: "100%" }}>
          <PerfilRealizacoes novoUsuario={false}></PerfilRealizacoes>
        </Grid>

      </Grid>
    </>
  );
};

const Paragrafo = styled(Typography)`
  font-size: 14px !important;
  padding-bottom: 10px;
`;

export default PPCStepper3;
